<template>
  <custom-dialog class="table-relation-setting-dialog" width="900px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <custom-table
        :data="tableList"
        :column="tableColumn"
        height="400px"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['saveDataType', 'dbType', 'saveDb', 'saveDbTable', 'action']"
        :filterArr="filterArr"
      >
        <template v-slot:saveDataType="scope">
          <custom-select v-model="scope.row.saveDataType" code="iot_topic_save_data_type" width="100%" value-type="number" :disabled="isWatch"></custom-select>
        </template>
        <template v-slot:dbType="scope">
          <custom-select v-model="scope.row.dbType" code="iot_topic_db_type" width="100%" :placeholder="scope.$index === 0 ? '' : $t('dms_table_relation_setting_dialog.tong_shang')" :disabled="isWatch"></custom-select>
        </template>
        <template v-slot:saveDb="scope">
          <el-input v-model="scope.row.saveDb" :placeholder="scope.$index === 0 ? '' : $t('dms_table_relation_setting_dialog.tong_shang')" :disabled="isWatch"></el-input>
        </template>
        <template v-slot:saveDbTable="scope">
          <el-input v-model="scope.row.saveDbTable" :placeholder="$t('Common.com_please_input')" :disabled="isWatch"></el-input>
        </template>
        <template v-slot:action="scope">
          <el-button size="mini" type="text" :disabled="isWatch" @click="del(scope.$index)">{{ $t('Common.com_delete') }}</el-button>
        </template>
      </custom-table>
      <div class="btn-content" v-if="!isWatch">
        <el-button @click="onAdd" class="add-relation-data">
          <i class="icon icon-add"></i>
          {{ $t('Common.com_added') }}
        </el-button>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('dms_table_relation_setting_dialog.que_ren') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis.js';

export default {
  mixins: [dialogMixins],
  props: {
    componentId: String,
  },
  data() {
    return {
      tableCode: 'table_relation_setting',
      visible: true,
      tableList: [],
      recordList: [],
      fullKeyArr: ['saveDataType', 'dbType', 'saveDb', 'saveDbTable'],
      checkKeyArr: ['saveDataType', 'dbType', 'saveDb', 'saveDbTable'],
    };
  },
  computed: {
    isWatch() {
      return this.model.type === 'watch';
    },
    filterArr() {
      return this.isWatch ? ['action'] : [];
    },
  },
  methods: {
    checkRelation(cb) {
      cb = cb || function () {};
      const checkList = this.getCheckList();

      if (checkList.length === 0) {
        const tips = this.$t('dms_table_relation_setting_dialog.lbbnwk');
        this.$message.error(tips);
        return cb(false);
      }

      if (checkList.some(item => !item.saveDataType)) {
        const tips = this.$t('dms_table_relation_setting_dialog.ccmsbnwk');
        this.$message.error(tips);
        return cb(false);
      }
      if (checkList.some(item => !item.dbType)) {
        const tips = this.$t('dms_table_relation_setting_dialog.sjklxbnwk');
        this.$message.error(tips);
        return cb(false);
      }
      if (checkList.some(item => !item.saveDb)) {
        const tips = this.$t('dms_table_relation_setting_dialog.sjkbnwkzfcdzc30gzf');
        this.$message.error(tips);
        return cb(false);
      }
      if (checkList.some(item => !item.saveDbTable)) {
        const tips = this.$t('dms_table_relation_setting_dialog.sjkbbnwkzfcdzc30gzf');
        this.$message.error(tips);
        return cb(false);
      }
      return cb(true);
    },
    closeDialog() {
      this.visible = false;
    },
    getTableList() {
      this.$getJSON(`${apis.ComponentDbList}/${this.componentId}`).then((res) => {
        this.tableList = this.fixArr(res.data);
      });
    },
    fixArr(arr, minLen = 3) {
      if (arr.length >= minLen) {
        return arr;
      }
      const len = minLen - arr.length;
      this.addRelation(arr, len);
      return arr;
    },
    del(index) {
      this.tableList.splice(index, 1);
    },
    addRelation(arr, len) {
      const ret = [];
      for (let i = 0; i < len; i++) {
        ret.push({
          saveDataType: '',
          dbType: '',
          saveDb: '',
          saveDbTable: '',
        });
      }
      arr.push(...ret);
      return ret;
    },
    onAdd() {
      this.addRelation(this.tableList, 1);
    },
    onConfirm() {
      this.validate((val) => {
        if (val) {
          this.checkRelation((validate) => {
            if (validate) {
              this.$postJSON(`${apis.ComponentDbSave}/${this.componentId}`, this.getReqData()).then(() => {
                this.$message({
                  message: this.$t('Common.com_handle_success'),
                  type: 'success',
                });
                this.closeDialog();
              });
            }
          });
        }
      });
    },
    getReqData() {
      return this.getCheckList();
    },
    validate(cb) {
      if (!this.tableList.length) {
        const tips = this.$t('dms_table_relation_setting_dialog.lbbnwk');
        this.$message.error(tips);
        return cb(false);
      }
      return cb(true);
    },
    getCheckList() {
      const arr = this.$formatCopyUp(this.tableList, ['dbType', 'saveDb']);
      return arr.filter(item => item.saveDataType || item.dbType || item.saveDb || item.saveDbTable);
    },
    copy(data) {
      return JSON.parse(JSON.stringify(data));
    },
  },
  mounted() {
    this.getTableColumn();
    this.getTableList();
  },
};
</script>

<style lang="scss">
.table-relation-setting-dialog {
  .btn-content {
    padding: 10px 0;
    .add-relation-data {
      width: 100%;
      margin: 10px 0;
      background: whitesmoke;
      border: 1px dashed #e4e4e4;
      color: #333333;
      font-size: 12px;
      .icon-add {
        color: #00afff;
        font-size: 10px;
        margin-right: 0px;
      }
    }
  }
}
</style>
